__turbopack_context__.v({
  "badge": "oZNOZa_badge",
  "buyNow": "oZNOZa_buyNow",
  "close": "oZNOZa_close",
  "description": "oZNOZa_description",
  "dialog": "oZNOZa_dialog",
  "finePrint": "oZNOZa_finePrint",
  "header": "oZNOZa_header",
  "overlay": "oZNOZa_overlay",
  "retailerLink": "oZNOZa_retailerLink",
  "retailerLogo": "oZNOZa_retailerLogo",
  "retailerName": "oZNOZa_retailerName",
  "retailers": "oZNOZa_retailers",
  "title": "oZNOZa_title",
});
